




































































































































































import Vue from 'vue';
import MStoreFormSelect from '@/components/shared/MStoreFormSelect.vue';
import InfoTooltip from '@/components/shared/InfoTooltip.vue';
import { LeaverRulesService } from '@/services/LeaversTool/LeaverRulesService';
import {
  EntityType,
  RetentionPeriodType,
  CabinetReferenceType,
  ReferenceValidationType,
  DocumentTypeModel,
  CabinetReferenceModel,
  LeaversToolConfigurationModel,
  LeaverRuleCreateUpdateModel
} from '@/types';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { FormFieldValidation, ModalHelpers } from '@/mixins';
import { EnumHelper } from '@/mixins/enumHelper';

export default Vue.extend({
  name: 'LeaverRuleForm',
  mixins: [FormFieldValidation, ModalHelpers],
  props: {
    ruleId: {
      required: false
    },
    configuration: {
      type: Object as () => LeaversToolConfigurationModel,
      required: true
    },
    rule: {
      type: Object as () => LeaverRuleCreateUpdateModel,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      filterRuleByReference: !!this.rule.referenceId,
      calcRetentionFromReference: !!this.rule.calculateFromReferenceId,
      disableRetentionPeriod: this.rule.retentionPeriodType === RetentionPeriodType.None
    };
  },
  methods: {
    handleSubmit(this: any) {
      if (!this.validateAllDropdownsPopulated() || !this.validateDifferentDocumentTypes() || !this.validateDocumentReferencesMatch()) {
        return;
      }
      this.$validator.validate().then((valid: any) => {
        if (valid) {
          this.isLoading = true;

          if (this.ruleId) {
            this.updateRule();
          } else {
            this.createRule();
          }

          this.isLoading = false;
        }
      });
    },
    validateAllDropdownsPopulated(this: any): boolean {
      if (
        this.rule.currentDocumentTypeId == null ||
        this.rule.destinationDocumentTypeId == null ||
        this.rule.retentionPeriodType == null ||
        (this.calcRetentionFromReference && !this.rule.calculateFromReferenceId)
      ) {
        this.$validator.errors.add({
          field: 'validationErrors',
          msg: 'A value must be selected in all dropdowns'
        });
        return false;
      } else {
        this.$validator.errors.remove('validationErrors');
        return true;
      }
    },
    validateDifferentDocumentTypes(): boolean {
      const different = this.rule.currentDocumentTypeId !== this.rule.destinationDocumentTypeId;

      if (different) {
        this.$validator.errors.remove('validationErrors');
      } else {
        this.$validator.errors.add({
          field: 'validationErrors',
          msg: 'The current document type and the destination document type cannot be the same'
        });
      }

      return different;
    },
    validateDocumentReferencesMatch(): boolean {
      const currentDocumentType = this.configuration.configurableCurrentDocumentTypes.find((x) => x.id === this.rule.currentDocumentTypeId);

      const destinationDocumentType = this.configuration.configurableDestinationDocumentTypes.find((x) => x.id === this.rule.destinationDocumentTypeId);

      let sameReferences: boolean = false;

      if (currentDocumentType !== undefined && destinationDocumentType !== undefined) {
        const currentDocumentReferences = currentDocumentType.references.filter((x) => x.type === CabinetReferenceType.Document);

        const destinationDocumentReferences = destinationDocumentType.references.filter((x) => x.type === CabinetReferenceType.Document);

        sameReferences = currentDocumentReferences.length === destinationDocumentReferences.length;

        if (sameReferences) {
          currentDocumentReferences.forEach((currentRef) => {
            if (!destinationDocumentReferences.find((x) => x.referenceDescription.trim().toLowerCase() === currentRef.referenceDescription.trim().toLowerCase())) {
              sameReferences = false;
            }
          });
        }
      }

      if (!sameReferences) {
        this.$validator.errors.add({
          field: 'validationErrors',
          msg: 'The document references for the current document type and the destination document type must be the same'
        });
      } else {
        this.$validator.errors.remove('validationErrors');
      }

      return sameReferences;
    },
    createRule(this: any) {
      LeaverRulesService.createAsync(this.configuration.id, this.rule)
        .then((response: any) => {
          SnotifyConfiguration.showSuccess('Rule added successfully.');
          this.setApplicationDirty(false);
          this.$router.push({ name: 'leaverRules' });
        })
        .catch((error: any) => {
          this.$validator.errors.add({
            field: 'serverValidationErrors',
            msg: error.notification
          });
        });
    },
    updateRule(this: any) {
      LeaverRulesService.updateAsync(this.configuration.id, this.ruleId, this.rule)
        .then((response: any) => {
          SnotifyConfiguration.showSuccess('Rule updated successfully.');
          this.setApplicationDirty(false);
          this.$router.push({ name: 'leaverRules' });
        })
        .catch((error: any) => {
          this.$validator.errors.add({
            field: 'serverValidationErrors',
            msg: error.notification
          });
        });
    },
    async cancel(this: any) {
      this.$router.back();
    },
    byReferenceToggled(checked: boolean) {
      if (!checked) {
        this.rule.referenceId = undefined;
      }
    },
    fromReferenceToggled(checked: boolean) {
      if (!checked) {
        this.rule.calculateFromReferenceId = undefined;
      }
    },
    currentDocumentTypeChanged(value: any) {
      this.filterRuleByReference = false;
      this.calcRetentionFromReference = false;
      this.rule.referenceId = undefined;
      this.rule.calculateFromReferenceId = undefined;
      this.rule.referenceValue = undefined;
    },
    retentionPeriodTypeChanged(value: any) {
      this.rule.retentionPeriodType = value;
      this.disableRetentionPeriod = value === RetentionPeriodType.None;

      if (value === RetentionPeriodType.None) {
        this.rule.retentionPeriod = null as any;
      }
    },
    updateRuleModel(this: any, fieldKey: string, newValue: any) {
      this.computedRule = { ...this.computedRule, [fieldKey]: newValue };
    }
  },
  computed: {
    computedRule: {
      get(this: any) {
        return this.rule;
      },
      set(this: any, newValue) {
        this.$emit('update:rule', newValue);
      }
    },
    retentionPeriodTypes() {
      return EnumHelper.methods.convertNumberBasedEnumToArray(RetentionPeriodType);
    },
    currentDocumentTypeSelected(this: any): boolean {
      return this.rule.currentDocumentTypeId !== undefined;
    },
    currentDocumentTypeReferences(this: any): CabinetReferenceModel[] {
      if (this.currentDocumentTypeSelected) {
        const currentDocumentType: DocumentTypeModel = this.configuration.configurableCurrentDocumentTypes.find((x: any) => x.id === this.rule.currentDocumentTypeId) as DocumentTypeModel;
        return currentDocumentType.references;
      }
      return [] as CabinetReferenceModel[];
    },
    dateCurrentDocumentTypeReferences(this: any): CabinetReferenceModel[] {
      return this.currentDocumentTypeReferences.filter((x: any) => x.referenceValidationType === ReferenceValidationType.Date);
    }
  },
  components: {
    MStoreFormSelect,
    InfoTooltip
  }
});
